__turbopack_context__.v({
  "button": "PlayPauseButton-module__-ARreW__button",
});
